import { Component, Input } from '@angular/core';
import { GlobalStateService } from 'src/app/services/global/global-state.service';
import { Invoice } from 'src/app/shared/models/invoice.interface';

/**
 * Shipping Information PDF Format Component
 *
 * This component renders invoices in a shipping instruction format
 * that displays detailed shipping information including:
 * - Shipper, consignee, and notify party details
 * - Vessel and voyage information
 * - Vehicle specifications and marks
 * - Booking and destination information
 *
 * Supports both individual and merged invoice modes.
 */
@Component({
  selector: 'app-shipping-information',
  templateUrl: './shipping-information.component.html',
  styleUrls: ['./shipping-information.component.scss']
})
export class ShippingInformationComponent {
  @Input() invoices: Invoice[] = [];
  @Input() viewMode: string = 'individual';

  constructor(private _globalService: GlobalStateService) { }

  settings: any = null;

  ngOnInit(): void {
    this.loadSettings();
  }

  loadSettings(): void {
    this._globalService.GetSetting().subscribe((res: any) => {
      this.settings = res.contacts?.english;
    });
  }

  formatDate(dateString: string | null): string {
    if (!dateString) return '-';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '-';
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    }).toUpperCase();
  }

  formatCurrency(amount: number | null, currency: string | null = 'USD'): string {
    if (!amount || amount === 0) return '-';
    const curr = currency || 'USD';
    return `${curr} ${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }

  // Helper method to get vehicle count for display
  getVehicleCount(invoice: any): number {
    if (this.viewMode === 'merged' && invoice.vehicles) {
      return invoice.vehicles.length;
    }
    return 1;
  }

  // Helper method to get destination country in uppercase
  getDestinationCountry(invoice: any): string {
    return invoice.order?.to_country?.toUpperCase() || 'DESTINATION COUNTRY';
  }

  // Helper method to safely access nested properties
  safeGet(obj: any, path: string, defaultValue: string = '-'): string {
    const value = path.split('.').reduce((current, key) => current?.[key], obj);
    return value || defaultValue;
  }
}
